import { ArrowLeftIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import { Separator } from '@/components/ui/separator';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { DOCUMENTS_PATH, getDocumentsReturnLabel, resolveDocumentsReturnTarget } from '@/features/chat/chat-space-navigation';

export function AppPageHeader({ ownerId, pageMeta }: { ownerId: string; pageMeta: { page: string; parent?: { href: string; label: string } | null } }) {
  const location = useLocation();
  const isDocumentsRoute = location.pathname === DOCUMENTS_PATH || location.pathname.startsWith(`${DOCUMENTS_PATH}/`);
  const documentsReturnTarget = isDocumentsRoute ? resolveDocumentsReturnTarget(ownerId, location.state) : null;
  return (
          <header className="flex h-16 shrink-0 items-center gap-2 border-b border-border/70 bg-card/95 backdrop-blur transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12">
            <div className="flex items-center gap-2 px-6 lg:px-8">
              <SidebarTrigger className="-ml-1 text-foreground md:hidden" />
              <Separator
                orientation="vertical"
                className="mr-2 data-[orientation=vertical]:h-4 data-[orientation=vertical]:self-center md:hidden"
              />
              {documentsReturnTarget ? (
                <Button
                  asChild
                  variant="ghost"
                  size="sm"
                  className="-ms-2 gap-1.5 text-muted-foreground hover:text-foreground"
                >
                  <Link to={documentsReturnTarget.path} data-testid="documents-back-button">
                    <ArrowLeftIcon className="size-4 rtl:rotate-180" aria-hidden />
                    {getDocumentsReturnLabel(documentsReturnTarget)}
                  </Link>
                </Button>
              ) : (
                <Breadcrumb>
                  <BreadcrumbList>
                    {pageMeta.parent ? (
                      <>
                        <BreadcrumbItem>
                          <BreadcrumbLink asChild>
                            <Link to={pageMeta.parent.href}>{pageMeta.parent.label}</Link>
                          </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                      </>
                    ) : null}
                    <BreadcrumbItem>
                      <BreadcrumbPage>{pageMeta.page}</BreadcrumbPage>
                    </BreadcrumbItem>
                  </BreadcrumbList>
                </Breadcrumb>
              )}
            </div>
          </header>
  );
}
